import { Box } from "@mui/material"
import { IRootState } from "app/model"
import { IAppConfirmMessage, IAppMessage } from "message/model"
import React from "react"
import { connect } from "react-redux"
import { AppMessage } from "./AppMessage"
import { ConfirmMessage } from "./ConfirmMessage"
import { OverlayMessages } from "./OverlayMessages"

export interface IMessageCenterProps {
  messages: IAppMessage[]
  confirmMessage: IAppConfirmMessage | undefined
}

const MessageCenterFn = React.memo(({ confirmMessage, messages }: IMessageCenterProps) => (
  <>
    <Box
      sx={{
        position: "fixed",
        left: 0,
        bottom: 0,
        zIndex: "100000",
        width: "100%",
        minWidth: "100%",
        maxWidth: "100%",
        height: "12rem",
        minHeight: "12rem",
        display: "flex",
        flexDirection: "column-reverse",
        alignContent: "center",
        pointerEvents: "none"
      }}>
      {confirmMessage && <ConfirmMessage confirmMessage={confirmMessage} />}
      {messages.map(m => (
        <AppMessage key={m.id} message={m} />
      ))}
    </Box>
    <OverlayMessages />
  </>
))

export const MessageCenter = connect(
  (state: IRootState): IMessageCenterProps => ({
    messages: state.message.messages,
    confirmMessage: state.message.confirmMessage
  })
)(MessageCenterFn)
